import { DateRangePresets } from '@reports/domain/types';
import { DEFAULT_START_HOUR, DEFAULT_END_HOUR } from '@reports/presentation/utils';
import type { ReportState } from './types';

const today = new Date();
today.setHours(0, 0, 0, 0);

export const reportsInitialState: ReportState = {
  currentReport: null,
  appliedFilters: {
    startDate: new Date(today),
    endDate: new Date(today),
    preset: DateRangePresets.TODAY,
    startHour: DEFAULT_START_HOUR,
    endHour: DEFAULT_END_HOUR,
    filters: {},
  },
  isInitialized: false,
};
